import type { FormInstance } from '@arco-design/web-react';

import { buildOptionFromRaw, syncOptionMetaFromRaw } from '@/delivery-type-plugin/platform/option-meta';

import { BARE_METAL_NODES_OPTION_META_KEYS } from '../fieldKeys';
import type { BareMetalNodesPaths } from '../types';

/** 物理节点列表项（RadioList record） */
export interface PhysicalNodeRecord {
  metadata?: { name?: string };
  key?: string;
  spec?: {
    gpus?: { model?: string }[];
    imageTags?: unknown;
    bootstrapNetwork?: { staticIpv4?: string };
  };
}

/** 非计价模式：写入 bmsNode 与 optionMeta.node；节点有静态 IP 时回填并标记只读来源 */
export function applyPhysicalNodeSelection(form: FormInstance, paths: BareMetalNodesPaths, record: PhysicalNodeRecord): string {
  const nodeName = String(record?.metadata?.name ?? record?.key ?? '').trim();
  const gpuName = record?.spec?.gpus?.[0]?.model || undefined;
  const imageTags = record?.spec?.imageTags || undefined;
  const nodeStaticIpv4 = String(record?.spec?.bootstrapNetwork?.staticIpv4 ?? '').trim();
  /** 上一节点带入的 IP：换到无静态 IP 的节点时需清掉，避免只读残留 */
  const prevFromNode = form.getFieldValue('_staticIpv4FromNode') === true;

  form.setFieldsValue({
    [paths.bmsNode]: nodeName,
    [paths.gpuName]: gpuName,
    [paths.imageTags]: imageTags,
    ...(nodeStaticIpv4
      ? { staticIpv4: nodeStaticIpv4, _staticIpv4FromNode: true }
      : {
          _staticIpv4FromNode: false,
          ...(prevFromNode ? { staticIpv4: undefined } : {}),
        }),
  });

  if (nodeName) {
    const built = buildOptionFromRaw(nodeName, record as Record<string, unknown>);
    syncOptionMetaFromRaw(form, nodeName, built, BARE_METAL_NODES_OPTION_META_KEYS.node);
  }

  return nodeName;
}
